"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const galleryImages = [{
  src: "https://harmless-hippo.10web.cloud/wp-content/uploads/2026/04/Image-4.jpeg?v=mg60a4ljow9",
  alt: "Heavy-duty truck unloading stone at a Dallas construction site"
}, {
  src: "https://harmless-hippo.10web.cloud/wp-content/uploads/2026/04/gallery_grid_stone.webp?v=paqxx466rzm",
  alt: "Lumber yard logistics with specialized material handling vehicles"
}, {
  src: "https://harmless-hippo.10web.cloud/wp-content/uploads/2026/04/Image-7.jpeg?v=xm6kxyjl5rm",
  alt: "TransitLink semi-truck fleet ready for regional southeast hauling"
}, {
  src: "https://harmless-hippo.10web.cloud/wp-content/uploads/2026/04/Image-5.jpeg?v=nlxtpg9unua",
  alt: "Industrial bulk material storage and distribution facility"
}, {
  src: "https://harmless-hippo.10web.cloud/wp-content/uploads/2026/04/Image-2.jpeg?v=0biwwxpfoa1a",
  alt: "Last-mile delivery van serving local DFW business customers"
}, {
  src: "https://harmless-hippo.10web.cloud/wp-content/uploads/2026/04/Image-6.jpeg?v=99udsj08sza",
  alt: "Professional logistics management for bulk commercial materials"
}];
export default function SupplyChainGallery() {
  const headerReveal = useRevealOnScroll({
    threshold: 0.1
  });
  const gridReveal = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="182655" id="fleet-in-action" className="bg-background text-foreground py-20 md:py-24 overflow-hidden">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div ref={headerReveal.ref} className={`mb-12 text-center transition-all duration-700 ${headerReveal.isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <h2 className="font-default text-4xl font-extrabold uppercase tracking-tighter text-foreground md:text-5xl">
            Fleet Logistics & Operations
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-xl font-mono text-muted-foreground">A glimpse into the robust logistics capability of Legacy Delivery Services, showcasing our capacity to handle bulk stone, lumber, furniture, regional merchant goods and industrial materials for businesses across DFW and the Southeast.</p>
        </div>

        <div ref={gridReveal.ref} className={`columns-1 gap-8 md:columns-3 transition-all duration-1000 delay-200 ${gridReveal.isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
          {galleryImages.map((image, i) => <div key={i} data-index={i} className="break-inside-avoid mb-8 group overflow-hidden rounded-sm border-2 border-border bg-card shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg">
              <img src={image.src} alt={image.alt} className="w-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" />
            </div>)}
        </div>
      </div>
    </section>;
}